<template>
	<div class="list">
		<swiper :options="swiperOption" >
			<swiper-slide v-for="item in imgArr" :key="item"><img :src="item"/></swiper-slide>
			<div class="swiper-pagination" slot="pagination"></div>
		</swiper>
	</div>	
</template>

<script>
  import config from '@/api/config.js'
  import axios from 'axios';
	import { swiper, swiperSlide } from 'vue-awesome-swiper'
	require("swiper/dist/css/swiper.css");
	const imgArr = [{
		src:'/static/img/share_img1.png'
	},{
		src:'/static/img/share_img2.png'
	},{
		src:'/static/img/share_img3.png'
	},{
		src:'/static/img/share_img4.png'
	}];
	export default {
		name: 'swipeList',
		components: {
			swiper,
			swiperSlide
		},
		data() {
			return {
				swiperOption: {
                    slidesPerView: 4,
                    spaceBetween: 10,
				},
				imgArr: []
			}
		},
		created() {
			this.getIndexData();
		},
		methods: {
			async getIndexData() {
				try {
					const response = await axios.get(config.baseUrl + '/index/pc');
					this.imgArr = response.data.data.firm_images;
				} catch (error) {
					console.error('请求失败:', error);
				}
			},
		},
  }
</script>

<style lang='scss'>
	.list {
		width:100%;
		left: 0;
		top: 790px;
		height: 222px;
        margin-bottom: -16px;
		img {
	        height: 210px;
	        left: 0;
			width: 100%;
	    }
	}
</style>



// WEBPACK FOOTER //
// swipeList.vue?51e19b38